export default {
  loading(state) {
    return state.isLoading;
  },
  snackBar(state) {
    return state.isSnackBar;
  },
  token(state) {
    return `${"Bearer "}${state.token}`;
  },
  esignToken(state) {
    return `${"Bearer "}${state.esignToken}`;
  },
  operation(state) {
    return state.operation;
  },
  operationUuid(state) {
    return state.operationUuid;
  },
  domainUuid(state) {
    return state.domainUuid;
  },
  documentUuid(state) {
    return state.documentUuid;
  },
  videoUuid(state) {
    return state.videoUuid;
  },
  cellphone(state) {
    return state.cellphone;
  },
  signBoxName(state) {
    return state.signBoxName;
  },
  attachDocumentUuid(state) {
    return state.attachDocumentUuid;
  },
  userEmail(state) {
    return state.userEmail;
  },
  userToken(state) {
    return state.userToken;
  },
  userUid(state) {
    return state.userUid;
  },
  userData(state) {
    return state.userData;
  },
  credits(state) {
    return state.credits;
  },
  usedones(state) {
    return state.usedones;
  },
  userLoggedIn(state) {
    return state.userLoggedIn;
  },
  currentLang(state){
    return state.currentLang;
  }
};
